module.exports = __webpack_public_path__ + "static/offices-content-image-square-one@2x-9498252ebeb3bf8b1821100b2380c2bd.jpg";